import { Component, Input } from '@angular/core';

@Component({
  selector: 'add-button',
  templateUrl: './add-button.component.html',
  standalone: false,
})
export class AddButtonComponent {
  @Input() size: number = 48;
  @Input() color: string = 'var(--icon-main-color)';
}
